import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { MenuServices } from "../../services";
import { Globals } from "../../../../globals";
import { ConfigurationServices } from '../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { MenuCreateDishSelectPage } from '../menu-create-dish-select/menu-create-dish-select';

/**
 * Generated class for the MenuCreateSelectTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-select-type',
  templateUrl: 'menu-create-select-type.html',
})
export class MenuCreateSelectTypePage {

  type: any = "";
  update_state: boolean = false;
  menu_uid: any;
  show_prices: boolean;
  new_menu: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public menuServices: MenuServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService) {

    //Params
    this.update_state = this.navParams.get('update');
    this.menu_uid = this.navParams.get('menu_uid');
    this.show_prices = this.navParams.get('show_prices');
    this.new_menu = this.navParams.get('new_menu');

    if (!this.update_state) { //Si create
      this.type = 'basic';
    }
  }

  ionViewWillEnter() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'type') != -1) {
      this.changeClass();
    }
  }

  changeClass() {
    //Ponemos filtro gris a las plantillas que la version no puede usar
    const type = document.getElementsByClassName('type');
    for (let i = this.globals.checkLimitsByLicense('daily_menu', 'type'); i < type.length; i++) {
      const slide = type[i] as HTMLElement;
      slide.style.backgroundColor = "#80808047";
    }
  }

  select(type) {
    switch (type) {
      case 'basic':
        this.type = type;
        break;
      case 'freestyle':
        if (this.globals.checkLimitsByLicense('daily_menu', 'type') != -1) { //Si no PRO ni BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'buffete':
        if (this.globals.checkLimitsByLicense('daily_menu', 'type') != -1) { //Si no PRO ni BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
      case 'aperitivo':
        if (this.globals.checkLimitsByLicense('daily_menu', 'type') != -1) { //Si no PRO ni BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.type = type;
        }
        break;
    }
  }

  selected() {
    this.type = "";
  }

  checkState(type) {
    if (this.type == type) {
      return true
    } else {
      return false
    }
  }

  submit() {
    if (this.update_state) {
      //Create
    } else {
      //Update

    }
  }

  insert() {
    if (this.type != '') {
      this.globals.GAtrackView('Menu', 'Menu - Select type - Create', this.globals.restaurant.email, 'Create/Update', 'Create select type', 'Menu', this.type);
      this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
        'style': this.type,
        'sections': this.getsections(),
      })

      this.globals.tourLaunchStep(6);
      //
      this.navCtrl.push(MenuCreateDishSelectPage, {
        update: false,
        section: 0,
        type: this.type,
        menu_uid: this.menu_uid,
        show_prices: this.show_prices,
        new_menu: this.new_menu
      });

    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-tipo-menu-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  getsections() {
    var ret;
    if (this.type == 'basic') {
      ret = {
        0: {
          dish: Array(),
          name: this.translate.instant('general-primeros')
        },
        1: {
          dish: Array(),
          name: this.translate.instant('general-segundos')
        },
        2: {
          dish: Array(),
          name: this.translate.instant('general-postres')
        }
      }

    } else if (this.type == 'buffete') {
      ret = {
        0: {
          dish: Array(),
          name: 'Buffete'
        },
      }

    } else if (this.type == 'aperitivo') {
      ret = {
        0: {
          dish: Array(),
          name: this.translate.instant('general-aperitivos')
        },
        1: {
          dish: Array(),
          name: this.translate.instant('general-primeros')
        },
        2: {
          dish: Array(),
          name: this.translate.instant('general-segundos')
        },
        3: {
          dish: Array(),
          name: this.translate.instant('general-postres')
        }
      }
    } else {
      ret = {
        0: {
          dish: Array(),
          name: this.translate.instant('general-todos')
        },
      }
    }
    return ret;
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-select-type/menu-create-select-type.ts